"use strict";
const _ = require('lodash');
const tree = require('./generated-category-tree');
function getPipeStringValuesHelper(node, existingPath, pipeStringResult) {
    const newValue = existingPath
        ? `${existingPath}|${node.localizedName}`
        : node.localizedName;
    pipeStringResult.push(newValue);
    const nodeChildren = node.children || {};
    for (let i = 0; i < Object.keys(nodeChildren).length; i++) {
        const childKey = Object.keys(nodeChildren)[i];
        getPipeStringValuesHelper(node.children[childKey], newValue, pipeStringResult);
    }
}
function getPipeStringValues() {
    const pipeStringResult = [];
    for (let i = 0; i < Object.keys(tree).length; i++) {
        const childKey = Object.keys(tree)[i];
        getPipeStringValuesHelper(tree[childKey], '', pipeStringResult);
    }
    return pipeStringResult.map(x => ({ productCategory: x }));
}
function getInheritedProperty(pipeString, property) {
    if (!pipeString)
        return undefined;
    const path = pipeString.replace(/\|/g, '.children.');
    const node = _.get(tree, path, {});
    if (_.get(node, property) !== undefined)
        return _.get(node, property);
    return getInheritedProperty(pipeString.split('|').slice(0, -1).join('|'), property);
}
function getInheritedPropertyWithFallback(pipeString, primaryProperty, fallbackProperty) {
    const foundPrimaryProperty = getInheritedProperty(pipeString, primaryProperty);
    if (foundPrimaryProperty === undefined)
        return getInheritedProperty(pipeString, fallbackProperty);
    return foundPrimaryProperty;
}
function findFirstPathWithPropertyHelper(node, key, value, currentPath = '') {
    const path = currentPath ? `${currentPath}|${node.name}` : node.name;
    if (!node) {
        return null;
    }
    if (_.get(node, key) === value) {
        return path;
    }
    if (!node.children)
        return null;
    for (let i = 0; i < Object.keys(node.children).length; i++) {
        const childKey = Object.keys(node.children)[i];
        const item = node.children[childKey];
        const foundInChild = findFirstPathWithPropertyHelper(item, key, value, path);
        if (foundInChild) {
            return foundInChild;
        }
    }
    return null;
}
function findFirstPathWithProperty(key, value) {
    for (let i = 0; i < Object.keys(tree).length; i++) {
        const childKey = Object.keys(tree)[i];
        const foundInChild = findFirstPathWithPropertyHelper(tree[childKey], key, value);
        if (foundInChild) {
            return foundInChild;
        }
    }
    throw new Error(`did not find key - value: ${key} ${value}`);
}
module.exports = {
    getPipeStringValues,
    getInheritedProperty,
    getInheritedPropertyWithFallback,
    tree,
    findFirstPathWithProperty,
};
